import {Component, EventEmitter, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {TicketViewEnum} from "../../ticket-view.enum";

@Component({
    selector: 'tm-ticket-completion',
    templateUrl: './tm-ticket-completion.component.html',
    styleUrls: ['./tm-ticket-completion.component.scss'],
    standalone: false
})
export class TmTicketCompletionComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was i

    @Output() changeMode: EventEmitter<TicketViewEnum> = new EventEmitter<TicketViewEnum>();

    statusOptions = [
        { label: 'Successful', value: 'Successful' },
        { label: 'Failed', value: 'Failed' },
        { label: 'Pending', value: 'Pending' }
    ];

    // Model values
    selectedStatus: string = 'Successful';
    completionDate: string = new Date().toLocaleDateString();  // Example date (current date)
    comments: string = '';


    constructor() {
    }

    ngOnInit(): void {

        this.initComponent();
        this.refreshComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent() {
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }


    handleBackToTicket() {
        this.changeMode.emit(TicketViewEnum.showTicket)
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        this.refreshComponent();
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

}
